import React from 'react';
import resume from '../data/resume';

const Skills = () => {
  const sectionStyle = {
    textAlign: 'left'
  };

  const promptStyle = {
    fontSize: '14px',
    color: '#00FF00',
    margin: '0 0 5px 0',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const headingStyle = {
    fontSize: 'clamp(16px, 4.5vw, 18px)',
    fontWeight: 'bold',
    margin: '0 0 15px 0',
    letterSpacing: '2px',
    color: '#00FF00',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace',
    paddingLeft: 'clamp(12px, 4vw, 30px)'
  };

  const listStyle = {
    listStyle: 'none',
    paddingLeft: 'clamp(12px, 4vw, 30px)',
    margin: 0
  };

  const itemStyle = {
    fontSize: '14px',
    margin: '0 0 8px 0',
    paddingLeft: '25px',
    position: 'relative',
    color: '#00FF00',
    lineHeight: '1.5',
    fontFamily: '"Courier New", "Monaco", "Menlo", "Consolas", monospace'
  };

  const bulletStyle = {
    position: 'absolute',
    left: '0',
    color: '#00FF00'
  };

  const categoryStyle = {
    fontWeight: 'bold',
    color: '#00FF00'
  };

  const skills = resume.skills;

  return (
    <section style={sectionStyle}>
      <div style={promptStyle}>$ ls -la skills/</div>
      <h2 style={headingStyle}>[ SKILLS ]</h2>
      <ul style={listStyle}>
        {skills.map((skill, index) => (
          <li key={index} style={itemStyle}>
            <span style={bulletStyle}>[+]</span>
            <span style={categoryStyle}>{skill.category}:</span> {skill.items.join(', ')}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Skills;
